import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import WhiteLogo from 'assets/images/logo_white.png';
// import Button from 'components/Button/AppButton';
import { ROUTES } from 'config/constants';
import { connect } from 'react-redux';
import cn from 'classnames';

export class SideMenu extends Component {
    state = {
        selectedPage: null
    }

    componentDidMount() {
        this.setPathAsSelected();
    }

    setPathAsSelected = () => {
        const { history: { location: { pathname } } } = this.props;

        this.setState({ selectedPage: pathname });
    }

    onListClick = (routeName) => {
        const { history } = this.props;

        history.push(routeName);
        this.setPathAsSelected();
    }

    render() {
        const { selectedPage } = this.state;
        const { role } = this.props;

        return (
            <div className='SideMenu'>
                <img src={WhiteLogo} className='SideMenu__logo' alt='Prism' />
                <div className={cn(['SideMenu__super-admin', role !== 'super-admin' ? 'SideMenu__super-admin--hidden' : null])}>
                    Super Admin
                </div>
                <div className='SideMenu__page-list' >
                    <div onClick={() => this.onListClick(ROUTES.DASHBOARD)} className={selectedPage === ROUTES.DASHBOARD ? 'SideMenu__page-list--selected' : null}>Dashboard</div>
                    <div onClick={() => this.onListClick(ROUTES.PRODUCT)} className={selectedPage === ROUTES.PRODUCT ? 'SideMenu__page-list--selected' : null}>Products</div>
                    <div onClick={() => this.onListClick(ROUTES.TRAINING_VIDEOS)} className={selectedPage === ROUTES.TRAINING_VIDEOS ? 'SideMenu__page-list--selected' : null}>Training Videos</div>
                    {role !== 'pdm' ? <div onClick={() => this.onListClick(ROUTES.USERS)} className={selectedPage === ROUTES.USERS ? 'SideMenu__page-list--selected' : null}>Users</div> : null}
                    <div onClick={() => this.onListClick(ROUTES.EDITOR)} className={selectedPage === ROUTES.EDITOR ? 'SideMenu__page-list--selected' : null}>Editor</div>
                    <div onClick={() => this.onListClick(ROUTES.NOTIFICATIONS)} className={selectedPage === ROUTES.NOTIFICATIONS ? 'SideMenu__page-list--selected' : null}>Notifications</div>
                </div>
            </div >
        );
    }
}
SideMenu.propTypes = {
    path: PropTypes.string,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
        location: PropTypes.shape({
            pathname: PropTypes.string.isRequired
        }).isRequired
    }).isRequired,
    role: PropTypes.string
};

const mapStateToProps = state => {
    return {
        role: state.auth.profile.role[0]
    };
};

export default connect(mapStateToProps, null)(SideMenu);
